module.exports = __webpack_public_path__ + "static/media/tech-nextgen-3.8d32e6b9.png";